import { usePage } from "@inertiajs/react"
import { Menu } from "lucide-react"

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { Button } from "@/components/ui/button"
import { useSidebar } from "@/components/ui/sidebar"

// The partner portal has no desktop header — the sidebar carries the nav. Below
// `md` the sidebar unmounts into a Sheet, so this bar is the only thing that can
// open it. Brand block mirrors PartnerSidebar's header.
export function PartnerMobileHeader() {
  const { toggleSidebar } = useSidebar()
  const { partner } = usePage().props as {
    partner?: { name?: string; logo_url?: string }
  }

  const partnerName = partner?.name ?? "Partner"
  const partnerInitials = partnerName
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase()

  return (
    <header className="bg-background/95 sticky top-0 z-20 flex h-14 shrink-0 items-center gap-2 border-b px-2 backdrop-blur md:hidden">
      <Button
        variant="ghost"
        size="icon"
        className="size-9"
        onClick={toggleSidebar}
        aria-label="Open menu"
      >
        <Menu className="size-5" />
      </Button>
      <div className="flex min-w-0 items-center gap-2">
        <Avatar className="size-7 rounded-md">
          {partner?.logo_url && (
            <AvatarImage
              src={partner.logo_url}
              alt={partnerName}
              className="rounded-md object-cover"
            />
          )}
          <AvatarFallback className="rounded-md bg-zinc-900 text-xs font-semibold text-white">
            {partnerInitials}
          </AvatarFallback>
        </Avatar>
        <span className="truncate text-sm font-semibold">{partnerName}</span>
      </div>
    </header>
  )
}
